/* Pool Busters — Concrete Pool Restoration page controller (no dependencies).
   The 3D scenes live in a separate lazily-injected bundle (pb-cp-scene.js); everything here works without it. */
(function () {
  'use strict';
  if (window.__PBCP_PAGE__) return; window.__PBCP_PAGE__ = true;
  var root = document.getElementById('pbcp'); if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var emit = function (el, name, detail) { if (el) el.dispatchEvent(new CustomEvent(name, { detail: detail })); };
  var params = new URLSearchParams(location.search);
  // asset URLs: Shopify passes a map (window.PBCP_ASSETS) built with asset_url; the preview uses assets/
  var ASSET = function (n) { var m = window.PBCP_ASSETS; return (m && m[n]) || 'assets/' + n; };
  var smooth = function () { return reduce ? 'auto' : 'smooth'; };
  if (params.has('review')) root.classList.add('pbcp-review');
  function press(list, on) { list.forEach(function (b) { b.setAttribute('aria-pressed', String(b === on)); }); }

  /* ---------- 3D bundle: injected after first paint so the poster and text come first ---------- */
  var sceneLoaded = false;
  function loadScene() {
    if (sceneLoaded) return; sceneLoaded = true;
    if (params.get('pbcp-3d') === 'off') { $$('[data-pbcp-stage]').forEach(function (s) { s.classList.add('is-static'); }); return; }
    var s = document.createElement('script'); s.src = root.getAttribute('data-scene-src') || ASSET('pb-cp-scene.js'); s.async = true;
    s.onerror = function () { $$('[data-pbcp-stage]').forEach(function (x) { x.classList.add('is-static'); }); };
    document.body.appendChild(s);
  }
  // The 3D scenes are built on the main thread. Starting them while the hero's layer reveal plays made the
  // reveal stall, so the bundle starts once the reveal has settled (or after 7 s), in an idle period, or
  // immediately if the visitor heads down the page first.
  function startSceneSoon() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(loadScene, { timeout: 1500 }); }
  addEventListener('pbcp:hero-settled', startSceneSoon, { once: true });
  setTimeout(startSceneSoon, 7000);
  addEventListener('scroll', function onS() { if (scrollY > innerHeight * 0.35) { removeEventListener('scroll', onS); loadScene(); } }, { passive: true });

  /* ---------- sticky rescue: a theme ancestor with overflow:hidden kills position:sticky ---------- */
  (function unblockSticky() {
    var el = root.parentElement;
    while (el && el !== document.documentElement) {
      var cs = getComputedStyle(el);
      if (cs.overflow === 'hidden' || cs.overflowY === 'hidden' || cs.overflowX === 'hidden') el.style.overflow = 'clip';
      el = el.parentElement;
    }
  })();

  /* ---------- sub-nav scroll-spy ---------- */
  (function subnav() {
    var links = $$('[data-pbcp-subnav] a'); if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) map[t.id] = a; });
    var bar = $('[data-pbcp-subnav]');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = map[e.target.id]; if (a) { a.setAttribute('aria-current', 'true'); bar.scrollTo({ left: a.offsetLeft - 24, behavior: smooth() }); }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  })();

  /* ---------- reveals ---------- */
  (function reveals() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = $$('.pbcp-head, .pbcp-facts > div, .pbcp-process li, .pbcp-vs, .pbcp-cmp, .pbcp-compare');
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('pbcp-rv'); io.observe(el); });
  })();

  /* ---------- accessible tabs ---------- */
  function tabs(list, onSelect) {
    var t = $$('[role="tab"]', list);
    var vertical = list.getAttribute('aria-orientation') === 'vertical';
    function select(i, focus) {
      t.forEach(function (b, k) {
        var on = k === i; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;
        var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) t[i].focus();
      if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: t[i].offsetLeft - 16, behavior: smooth() });
      onSelect && onSelect(i, t[i]);
    }
    t.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        var n = t.length, j = null, k = e.key;
        if (k === 'ArrowRight' || (vertical && k === 'ArrowDown')) j = (i + 1) % n;
        else if (k === 'ArrowLeft' || (vertical && k === 'ArrowUp')) j = (i - 1 + n) % n;
        else if (k === 'Home') j = 0; else if (k === 'End') j = n - 1;
        if (j !== null) { e.preventDefault(); select(j, true); }
      });
    });
    return select;
  }

  // <template> innerHTML re-escapes '&', so read the raw text of its content
  function tplJSON(sel) { var t = $(sel); if (!t) return {}; try { return JSON.parse((t.content ? t.content.textContent : t.textContent) || '{}'); } catch (e) { return {}; } }

  /* ---------- shared: load a numbered frame sequence (desktop or phone size) ----------
     Frames load in priority order, and a frame that fails or is slow never blocks the others: callers draw
     the nearest frame that has arrived. */
  function seqName(prefix, i, mobile) { return ASSET(prefix + (mobile ? 'm' : '') + (i < 9 ? '0' : '') + (i + 1) + '.webp'); }
  function frames(prefix, n, mobile, order, onEach) {
    var ims = new Array(n), seq = order || Array.from({ length: n }, function (_, i) { return i; }), k = 0, live = 0;
    return new Promise(function (done) {
      function pump() {
        while (live < 6 && k < seq.length) {
          (function (i) {
            live++;
            var im = new Image(); im.decoding = 'async';
            var fin = function (ok) { live--; if (ok) { ims[i] = im; onEach && onEach(i, im); } pump(); if (!live && k >= seq.length) done(ims); };
            im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(function () { fin(true); }, function () { fin(true); }); };
            im.onerror = function () { fin(false); };
            im.src = seqName(prefix, i, mobile);
          })(seq[k++]);
        }
      }
      pump();
    });
  }
  function nearest(ims, i) { if (ims[i]) return ims[i]; for (var d = 1; d < ims.length; d++) { if (ims[i - d]) return ims[i - d]; if (ims[i + d]) return ims[i + d]; } return null; }
  function readJSON(sel) { var t = $(sel); try { return JSON.parse(t.textContent || '{}'); } catch (e) { return {}; } }

  /* ---------- hero: the pool comes apart into its layers, holds, and settles back ---------- */
  (function exploded() {
    var box = $('[data-pbcp-hx]'); if (!box) return;
    var hero = $('.pbcp-hero'), cv = $('.pbcp-hx__canvas', box), ctx = cv.getContext('2d', { alpha: false });
    var data = readJSON('[data-pbcp-hx-data]'), N = data.n || 40, LB = data.labels || [];
    var labels = $$('.pbcp-hx__labels li', box), toggle = $('[data-pbcp-hx-toggle]');
    var imgs = null, f = 0, raf = 0, open = false, busy = false, autoDone = false;
    var isMob = box.clientWidth < 760, boxW = box.clientWidth, mobile = function () { return isMob; };   // read once per layout, not per frame
    function layout() {
      var d = Math.min(devicePixelRatio || 1, 2), W = box.clientWidth, H = box.clientHeight; isMob = W < 760; boxW = W;
      labels.forEach(function (li) { li._w = li.offsetWidth || 160; });
      cv.width = Math.round(W * d); cv.height = Math.round(H * d);
      draw();
    }
    // wide screens: the layers sit right of the copy; phones: the stack fills the width. The studio backdrop
    // is a soft gradient, so the frame's edge pixels are stretched out to fill whatever the frame doesn't cover.
    function geom(im) {
      // the camera dollies out as the pool comes apart; scaling the frame with it keeps the assembled pool
      // clear of the copy and the exploded stack (with its labels) inside the screen
      var W = cv.width, H = cv.height, t = f / Math.max(1, N - 1), L = function (a, b) { return a + (b - a) * t; }, s, x;
      if (mobile()) { s = W / (im.width * L(0.86, 0.7)); x = W * 0.02 - L(0.15, 0.29) * im.width * s; }
      else { s = Math.max(W / im.width, H / im.height) * L(0.6, 0.86); x = W * L(0.665, 0.635) - im.width * s * 0.5; }
      var dw = im.width * s, dh = im.height * s;
      return { x: x, y: (H - dh) / 2, w: dw, h: dh };
    }
    function draw() {
      if (!imgs) return;
      var im = nearest(imgs, Math.round(f)); if (!im) return;
      var g = geom(im), W = cv.width, H = cv.height, iw = im.width, ih = im.height, e = 6;
      var x1 = g.x + g.w, y1 = g.y + g.h;
      if (g.x > 0) ctx.drawImage(im, 0, 0, e, ih, 0, g.y, g.x + 1, g.h);
      if (x1 < W) ctx.drawImage(im, iw - e, 0, e, ih, x1 - 1, g.y, W - x1 + 1, g.h);
      if (g.y > 0) ctx.drawImage(im, 0, 0, iw, e, g.x, 0, g.w, g.y + 1);
      if (y1 < H) ctx.drawImage(im, 0, ih - e, iw, e, g.x, y1 - 1, g.w, H - y1 + 1);
      if (g.x > 0 && g.y > 0) ctx.drawImage(im, 0, 0, e, e, 0, 0, g.x + 1, g.y + 1);
      if (x1 < W && g.y > 0) ctx.drawImage(im, iw - e, 0, e, e, x1 - 1, 0, W - x1 + 1, g.y + 1);
      if (g.x > 0 && y1 < H) ctx.drawImage(im, 0, ih - e, e, e, 0, y1 - 1, g.x + 1, H - y1 + 1);
      if (x1 < W && y1 < H) ctx.drawImage(im, iw - e, ih - e, e, e, x1 - 1, y1 - 1, W - x1 + 1, H - y1 + 1);
      ctx.drawImage(im, g.x, g.y, g.w, g.h);
      var row = LB[Math.round(f)] || {}, d = cv.width / box.clientWidth;
      labels.forEach(function (li) {
        var p = row[li.getAttribute('data-k')]; if (!p) return;
        var lx = Math.min((g.x + p[0] * g.w) / d, boxW - (li._w || 160) - 12);   // labels never run off the right edge
        li.style.transform = 'translate(' + lx.toFixed(1) + 'px,' + ((g.y + p[1] * g.h) / d).toFixed(1) + 'px) translate(-3px, -50%)';
      });
    }
    function to(target, fps) {
      return new Promise(function (res) {
        cancelAnimationFrame(raf); busy = true;
        var last = performance.now(), dir = target > f ? 1 : -1;
        (function step(now) {
          f += dir * (now - last) / 1000 * fps; last = now;
          if ((dir > 0 && f >= target) || (dir < 0 && f <= target)) { f = target; draw(); busy = false; res(); return; }
          draw(); raf = requestAnimationFrame(step);
        })(last);
      });
    }
    function setOpen(v) {
      open = v; box.classList.toggle('is-open', v);
      toggle.setAttribute('aria-pressed', String(v)); $('span', toggle).textContent = v ? 'Put it back together' : 'See what\u2019s beneath';
    }
    function explode() { box.classList.remove('is-open'); return to(N - 1, 22).then(function () { setOpen(true); }); }
    function assemble() { setOpen(false); return to(0, 26); }
    toggle.addEventListener('click', function () {
      if (!imgs || busy) return; autoDone = true;
      if (open) assemble(); else explode();
      dispatchEvent(new CustomEvent('pbcp:hero-settled'));
    });
    var order = [0, N - 1]; for (var q = 1; q < N - 1; q++) order.push(q);
    frames('pbcp-hx-', N, mobile(), order).then(function (ims) {
      var settled = function () { dispatchEvent(new CustomEvent('pbcp:hero-settled')); };
      if (!ims[0] || !ims[N - 1]) { settled(); return; }          // poster stays; the page is fully usable without the sequence
      imgs = ims; layout(); box.classList.add('is-ready'); hero.classList.add('is-ready');
      if ('ResizeObserver' in window) new ResizeObserver(layout).observe(box);
      if (reduce) { f = N - 1; draw(); setOpen(true); settled(); return; }
      // the reveal plays once on arrival: apart, a beat to read the layers, then back together
      setTimeout(function () {
        if (autoDone) return;
        explode().then(function () { setTimeout(function () { if (!autoDone && open) assemble().then(settled); else settled(); }, 3400); });
      }, 700);
    });
  })();

  /* ---------- up close: a section of pool wall, stepped through with in-section controls ---------- */
  (function core() {
    var sec = $('[data-pbcp-core]'); if (!sec) return;
    var cv = $('.pbcp-core__canvas', sec), ctx = cv.getContext('2d'), stage = $('.pbcp-core__stage', sec), poster = $('.pbcp-core__poster', sec);
    var data = readJSON('[data-pbcp-core-data]'), N = data.n || 60, LB = data.labels || [];
    var STAGE = [1, 20, 36, 42, 50, 60].map(function (x) { return x - 1; });
    var steps = $$('.pbcp-core__step', sec), labels = $$('.pbcp-core__labels li', sec);
    var prev = $('[data-core-prev]', sec), next = $('[data-core-next]', sec), count = $('[data-core-count]', sec);
    var imgs = [], f = 0, target = 0, cur = 0, raf = 0, last = 0, started = false, mob = false;
    function layout() { var d = Math.min(devicePixelRatio || 1, 2); cv.width = Math.round(stage.clientWidth * d); cv.height = Math.round(stage.clientHeight * d); draw(); }
    function draw() {
      var k = Math.round(f), im = nearest(imgs, k);
      if (im) { ctx.clearRect(0, 0, cv.width, cv.height); ctx.drawImage(im, 0, 0, cv.width, cv.height); }
      var row = LB[k] || {}, fr = k + 1;
      labels.forEach(function (li) {
        var p = row[li.getAttribute('data-k')], on = p && fr >= +li.getAttribute('data-from') && fr <= +li.getAttribute('data-to');
        li.classList.toggle('is-on', !!on); if (!p) return;
        var left = p[0] < 0.5; li.classList.toggle('is-left', left);
        li.style.left = (p[0] * 100).toFixed(2) + '%'; li.style.top = (p[1] * 100).toFixed(2) + '%';
        li.style.transform = left ? 'translate(-3px, -50%)' : 'translate(calc(-100% + 3px), -50%)';
      });
    }
    // play the frames between the current step and the chosen one (about 0.9 s, whatever the distance)
    function tick(now) {
      raf = 0; var dt = Math.min(64, now - (last || now)); last = now;
      var speed = Math.max(24, Math.abs(target - f) / 0.9);
      var dir = target > f ? 1 : -1; f += dir * speed * dt / 1000;
      if ((dir > 0 && f >= target) || (dir < 0 && f <= target)) f = target;
      draw(); if (f !== target) raf = requestAnimationFrame(tick); else last = 0;
    }
    function go(i, instant) {
      cur = Math.max(0, Math.min(STAGE.length - 1, i)); target = STAGE[cur];
      steps.forEach(function (li, k) { li.classList.toggle('is-on', k === cur); li.classList.toggle('is-done', k < cur); var b = $('button', li); b.setAttribute('aria-current', k === cur ? 'step' : 'false'); });
      count.textContent = '0' + (cur + 1); prev.disabled = cur === 0; next.disabled = cur === STAGE.length - 1;
      $('span', next) && ($('span', next).textContent = cur === STAGE.length - 1 ? 'Done' : 'Next step');
      // until the sequence has loaded, the still for this step is shown directly
      if (!sec.classList.contains('is-ready')) poster.src = seqName('pbcp-core-', target, mob);
      if (instant || reduce || !sec.classList.contains('is-ready')) { cancelAnimationFrame(raf); raf = 0; f = target; draw(); return; }
      if (!raf) { last = 0; raf = requestAnimationFrame(tick); }
    }
    $$('[data-core-go]', sec).forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-core-go')); }); });
    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur + 1); });
    sec.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { if (cur < STAGE.length - 1) { e.preventDefault(); go(cur + 1); } }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { if (cur > 0) { e.preventDefault(); go(cur - 1); } }
    });
    // phones: swipe the image left/right to move between steps
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
    function load() {
      if (started) return; started = true;
      mob = stage.clientWidth < 520;
      // step stills first, then the in-between frames
      var order = STAGE.slice(); for (var q = 0; q < N; q++) if (order.indexOf(q) < 0) order.push(q);
      frames('pbcp-core-', N, mob, order).then(function (ims) {
        imgs = ims; if (!ims[STAGE[cur]]) return;     // keep showing the stills if the sequence could not load
        layout(); sec.classList.add('is-ready'); f = target; draw();
        if ('ResizeObserver' in window) new ResizeObserver(layout).observe(stage);
      });
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(); }, { rootMargin: '1200px 0px' }).observe(sec); else load();
    go(0, true);
  })();

  /* ---------- gallery: filter by type of work, first 9 photos until "Show all" ---------- */
  (function gallery() {
    var grid = $('[data-pbcp-gallery]'); if (!grid) return;
    var figs = $$('.pbcp-job', grid), chips = $$('.pbcp-chip'), more = $('[data-pbcp-more]'), count = $('[data-count]');
    var cat = 'all', open = false, LIMIT = 9;
    function show() {
      var list = figs.filter(function (f) { return cat === 'all' || f.getAttribute('data-cat') === cat; });
      figs.forEach(function (f) { f.hidden = true; });
      list.forEach(function (f, i) { f.hidden = !(open || cat !== 'all' || i < LIMIT); });
      count.textContent = list.length;
      more.parentNode.hidden = open || cat !== 'all' || list.length <= LIMIT;
    }
    chips.forEach(function (b) { b.addEventListener('click', function () { cat = b.getAttribute('data-cat'); press(chips, b); show(); }); });
    more.addEventListener('click', function () { open = true; show(); var f = figs[LIMIT]; if (f) { var im = $('img', f); if (im) im.focus && f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); } });
    show();
  })();

  /* ---------- 01 services ---------- */
  (function services() {
    var list = $('[data-pbcp-tabs="svc"]'); if (!list) return;
    var t = $$('[role="tab"]', list);
    var select = tabs(list);
    function bySvc(id) { var i = t.findIndex(function (b) { return b.getAttribute('data-svc') === id; }); if (i >= 0) select(i); }
    $$('[data-pbcp-svc]').forEach(function (a) { a.addEventListener('click', function () { bySvc(a.getAttribute('data-pbcp-svc')); }); });
  })();

  /* ---------- 02 surface preparation: chapter in the middle of the viewport drives the stage ---------- */
  (function story() {
    var stage = $('[data-pbcp-stage="story"]'); if (!stage) return;
    var chapters = $$('[data-pbcp-chapter]');
    var posters = $$('.pbcp-story__posters img', stage);
    var current = -1;
    function set(i) {
      if (i === current || i < 0) return; current = i;
      chapters.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      posters.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      $$('[data-pbcp-goto]', stage).forEach(function (b) { b.setAttribute('aria-current', String(+b.getAttribute('data-pbcp-goto') === i)); });
      stage.setAttribute('data-active-chapter', String(i));
      emit(stage, 'pbcp:chapter', i);
    }
    set(0);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) set(chapters.indexOf(e.target)); });
      }, { rootMargin: '-48% 0px -48% 0px' });
      chapters.forEach(function (c) { io.observe(c); });
    }
    $$('[data-pbcp-goto]', stage).forEach(function (b) {
      b.addEventListener('click', function () { var c = chapters[+b.getAttribute('data-pbcp-goto')]; if (c) c.scrollIntoView({ behavior: smooth(), block: 'center' }); });
    });
    stage.addEventListener('pbcp:ready', function () { emit(stage, 'pbcp:chapter', current); });
  })();

  /* ---------- 02b close-up: six steps of the restoration on one surface ---------- */


  /* ---------- 03 tile & finishes configurator ---------- */
  (function edge() {
    var stage = $('[data-pbcp-stage="edge"]'); if (!stage) return;
    var about = $('[data-edge-about]');
    var ABOUT = {
      'glass-ocean': ['Glass mosaic', 'Impervious and colour-stable, with a depth that changes with the light. Rated for submerged use.'],
      'glass-aqua': ['Glass mosaic', 'Impervious and colour-stable, with a depth that changes with the light. Rated for submerged use.'],
      'glass-midnight': ['Glass mosaic', 'Impervious and colour-stable, with a depth that changes with the light. Rated for submerged use.'],
      'glass-pearl': ['Glass mosaic', 'Impervious and colour-stable, with a depth that changes with the light. Rated for submerged use.'],
      'porc-slate': ['Porcelain mosaic', 'Dense, impervious and frost-resistant — a hard-wearing, understated waterline.'],
      'porc-graphite': ['Porcelain mosaic', 'Dense, impervious and frost-resistant — a hard-wearing, understated waterline.'],
      'porc-ivory': ['Porcelain mosaic', 'Dense, impervious and frost-resistant — a hard-wearing, understated waterline.'],
      limestone: ['Limestone coping', 'Warm and refined. Back-proofed and sealed for freeze–thaw conditions.'],
      travertine: ['Travertine coping', 'Warm, banded and cool underfoot. Porous, so it is sealed — and the stone is checked for density.'],
      granite: ['Granite coping', 'Among the most frost-resistant natural stones; dense and very durable.'],
      bluestone: ['Bluestone coping', 'A classic natural-cleft stone with good freeze–thaw performance.'],
      'epoxy-white': ['Two-part epoxy', 'A hard, sealed, satin-gloss coating — the usual choice for restoring a previously painted pool.'],
      'epoxy-blue': ['Two-part epoxy', 'A hard, sealed, satin-gloss coating — the usual choice for restoring a previously painted pool.'],
      'epoxy-grey': ['Two-part epoxy', 'A hard, sealed, satin-gloss coating — the usual choice for restoring a previously painted pool.'],
      marcite: ['Marcite', 'Traditional white-cement and marble-dust plaster with a soft, matte finish.'],
      marbelite: ['Marbelite', 'Marble-based pool plaster with a fine, bright texture.'],
    };
    function info(key) { var a = ABOUT[key]; if (a && about) { about.innerHTML = '<strong></strong><span></span>'; about.firstChild.textContent = a[0]; about.lastChild.textContent = a[1]; } }
    function bind(attr, key) {
      var bs = $$('[' + attr + ']', stage.parentNode);
      bs.forEach(function (b) { b.addEventListener('click', function () {
        var v = b.getAttribute(attr); var d = {}; d[key] = v;
        if (key === 'tile') press($$('[data-edge-tile]'), b); else press(bs, b);
        emit(stage, 'pbcp:edge', d); if (key !== 'view') info(v);
        if (key === 'tile' || key === 'coping') emit(stage, 'pbcp:edge', { view: key === 'tile' ? 'waterline' : 'coping' });
        if (key === 'interior') emit(stage, 'pbcp:edge', { view: 'interior' });
        if (key !== 'view') syncViews(key === 'tile' ? 'waterline' : key === 'coping' ? 'coping' : 'interior');
      }); });
    }
    function syncViews(v) { press($$('[data-edge-view]'), $('[data-edge-view="' + v + '"]')); }
    bind('data-edge-tile', 'tile'); bind('data-edge-coping', 'coping'); bind('data-edge-interior', 'interior');
    $$('[data-edge-view]').forEach(function (b) { b.addEventListener('click', function () { syncViews(b.getAttribute('data-edge-view')); emit(stage, 'pbcp:edge', { view: b.getAttribute('data-edge-view') }); }); });
    function toggle(sel, key, after) {
      var b = $(sel); if (!b) return;
      b.addEventListener('click', function () { var on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', String(on)); var d = {}; d[key] = on; emit(stage, 'pbcp:edge', d); after && after(on); });
      return b;
    }
    var eve = toggle('[data-edge-evening]', 'evening', function (on) { if (on) { syncViews('pool'); emit(stage, 'pbcp:edge', { view: 'pool' }); } });
    toggle('[data-edge-before]', 'before');
    $$('[data-pbcp-evening]').forEach(function (a) { a.addEventListener('click', function () { if (eve && eve.getAttribute('aria-pressed') !== 'true') setTimeout(function () { eve.click(); }, 900); }); });
    info('glass-ocean');
  })();

  /* ---------- 04 structural: modes, parts, damage explorer, groundwater ---------- */
  (function structural() {
    var stage = $('[data-pbcp-stage="structure"]'); if (!stage) return;
    var list = $('[data-pbcp-tabs="mode"]');
    var mode = 'anatomy';
    var stills = $$('[data-mode-still]', stage);
    var selectMode = tabs(list, function (i, b) {
      mode = b.getAttribute('data-mode');
      stage.setAttribute('data-mode', mode); stage.setAttribute('data-focus', '');
      stills.forEach(function (s) { s.hidden = s.getAttribute('data-mode-still') !== mode; });
      emit(stage, 'pbcp:mode', mode);
      resetParts(); resetIssues(); press($$('[data-gw]'), $('[data-gw="0"]'));
    });
    $$('[data-pbcp-mode-link]').forEach(function (a) { a.addEventListener('click', function () {
      var m = a.getAttribute('data-pbcp-mode-link'); var i = $$('[role="tab"]', list).findIndex(function (b) { return b.getAttribute('data-mode') === m; });
      if (i >= 0) setTimeout(function () { selectMode(i); }, 500);
    }); });

    // anatomy parts
    var pdata = tplJSON('[data-pbcp-part-data]');
    var ppanel = $('[data-pbcp-part-panel]'), pintro = $('[data-pbcp-part-intro]'), pbtns = $$('[data-part]');
    function resetParts() { press(pbtns, null); ppanel.hidden = true; pintro.hidden = false; }
    function part(id) {
      var d = pdata[id];
      stage.setAttribute('data-focus', id || '');
      emit(stage, 'pbcp:part', id || '');
      if (!d) { resetParts(); return; }
      press(pbtns, $('[data-part="' + id + '"]'));
      pintro.hidden = true; ppanel.hidden = false;
      $('[data-f="title"]', ppanel).textContent = d.title;
      $('[data-f="does"]', ppanel).textContent = d.does;
      $('[data-f="fails"]', ppanel).textContent = d.fails;
      var ol = $('[data-f="steps"]', ppanel); ol.innerHTML = '';
      d.steps.forEach(function (s) { var li = document.createElement('li'); li.textContent = s; ol.appendChild(li); });
      var lk = $('[data-f="link"]', ppanel); lk.innerHTML = '';
      if (d.link) { lk.appendChild(document.createTextNode('Related: ')); var a = document.createElement('a'); a.href = d.link[0]; a.textContent = d.link[1]; lk.appendChild(a); }
      if (window.innerWidth < 900) stage.scrollIntoView({ behavior: smooth(), block: 'start' });
    }
    pbtns.forEach(function (b) { b.addEventListener('click', function () { var id = b.getAttribute('data-part'); part(stage.getAttribute('data-focus') === id ? '' : id); }); });

    // damage explorer
    var data = tplJSON('[data-pbcp-issue-data]');
    var panel = $('[data-pbcp-issue-panel]'), intro = $('[data-pbcp-issue-intro]');
    var range = $('[data-pbcp-repair]'), playBtn = $('[data-pbcp-repair-play]'), still = $('.pbcp-issue-still', stage);
    var SEV = { cosmetic: 'Usually cosmetic', repair: 'Repair', assess: 'Assessment recommended' };
    var cur = '';
    var field = function (n) { return $('[data-field="' + n + '"]', panel); };
    function steps(v) { $$('li', field('steps')).forEach(function (li, k) { li.classList.toggle('is-on', v >= k * 0.75 - 0.01 && (v > 0.02 || k === 0)); }); }
    function showStill(v) {
      if (!still) return;
      if (stage.classList.contains('is-live') || !cur) { still.hidden = true; return; }
      still.hidden = false; still.src = ASSET('pbcp-issue-' + cur + (v > 1 ? '-c' : '-a') + '.webp');
    }
    function resetIssues() { cur = ''; $$('.pbcp-issues [data-pbcp-issue]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); panel.hidden = true; intro.hidden = false; showStill(0); }
    function issue(id) {
      cur = id || '';
      stage.setAttribute('data-focus', cur);
      $$('.pbcp-issues [data-pbcp-issue]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pbcp-issue') === cur)); });
      emit(stage, 'pbcp:focus', cur);
      if (!cur) { resetIssues(); return; }
      var d = data[cur]; if (!d) return;
      intro.hidden = true; panel.hidden = false;
      var sev = field('sevlabel'); sev.textContent = SEV[d.sev]; sev.setAttribute('data-sev', d.sev);
      field('title').textContent = d.title; field('see').textContent = d.see; field('note').textContent = d.note;
      field('causes').innerHTML = ''; d.causes.forEach(function (c) { var li = document.createElement('li'); li.textContent = c; field('causes').appendChild(li); });
      field('steps').innerHTML = ''; d.steps.forEach(function (c) { var li = document.createElement('li'); li.textContent = c; field('steps').appendChild(li); });
      range.value = 0; steps(0); showStill(0);
      emit(stage, 'pbcp:repair', { id: cur, value: 0 });
    }
    $$('[data-pbcp-issue], [data-pbcp-spot]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-pbcp-issue') || b.getAttribute('data-pbcp-spot');
        issue(id === cur && b.closest('.pbcp-issues') ? '' : id);
        if (id && window.innerWidth < 900 && b.closest('.pbcp-issues')) stage.scrollIntoView({ behavior: smooth(), block: 'start' });
      });
    });
    range.addEventListener('input', function () { var v = +range.value; steps(v); showStill(v); emit(stage, 'pbcp:repair', { id: cur, value: v }); });
    playBtn.addEventListener('click', function () {
      if (stage.classList.contains('is-live')) emit(stage, 'pbcp:repair', { id: cur, play: true });
      else { range.value = 2; steps(2); showStill(2); }
    });
    stage.addEventListener('pbcp:repair-progress', function (e) { if (e.detail.id !== cur) return; range.value = e.detail.value; steps(e.detail.value); });

    // groundwater steps
    $$('[data-gw]').forEach(function (b) { b.addEventListener('click', function () { press($$('[data-gw]'), b); emit(stage, 'pbcp:gw', +b.getAttribute('data-gw')); }); });

    // shared back button + Escape
    $('[data-pbcp-back]', stage).addEventListener('click', function () { if (mode === 'anatomy') part(''); else issue(''); });
    stage.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (mode === 'anatomy') part(''); else issue(''); } });
  })();

  /* ---------- compare frames ---------- */
  (function compares() {
    $$('.pbcp-compare__frame').forEach(function (frame) {
      var r = $('input[type="range"]', frame); if (!r) return;
      r.addEventListener('input', function () { frame.style.setProperty('--pos', r.value + '%'); });
    });
  })();

  /* ---------- 06 commercial: markings plan ---------- */
  (function plan() {
    var svg = $('[data-pbcp-plan]'), note = $('[data-plan-note]'); if (!svg) return;
    var NOTES = {
      depth: 'Deck depth markings show the shallow and deep points and breaks in slope. Example layout — markings follow your facility\'s requirements.',
      lanes: 'Lane lines and end targets on the pool floor, laid out to suit how your pool is used.',
      safety: 'Contrasting markings such as the break in slope, and the black disc at the deepest point used for water-clarity checks.',
    };
    var bs = $$('[data-plan]');
    bs.forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-plan'); press(bs, b); svg.setAttribute('data-show', k); note.textContent = NOTES[k]; }); });
  })();

  /* ---------- project type presets (commercial CTAs) ---------- */
  function setType(t) {
    var r = $('input[name="project_type"][value="' + t + '"]'); if (!r) return;
    r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
  }
  $$('[data-pbcp-type]').forEach(function (a) {
    a.addEventListener('click', function () { if (a.getAttribute('href') === '#quote') setType(a.getAttribute('data-pbcp-type') === 'commercial' ? 'Commercial' : 'Residential'); });
  });

  /* ---------- guide (one question at a time) ---------- */
  var guideAnswers = [];
  (function guide() {
    var box = $('[data-pbcp-quiz]'); if (!box) return;
    var Q = {
      start: { q: 'What kind of pool is it?', o: [{ t: 'A residential pool', next: 'concern' }, { t: 'A commercial pool', s: 'Hotel, condo, apartment or facility', tag: 'commercial', next: 'concern' }] },
      concern: { q: 'What are you noticing most?', o: [
        { t: 'Peeling, faded or failing paint', tag: 'peel', next: 'fill' },
        { t: 'Rough, etched or stained plaster', tag: 'plaster', next: 'fill' },
        { t: 'Cracked, loose or missing tile', tag: 'tile', next: 'fill' },
        { t: 'Loose or cracked coping', tag: 'coping', next: 'fill' },
        { t: 'Cracks, spalling or crumbling concrete', s: 'Including at the waterline or skimmer', tag: 'struct', next: 'cracks' },
        { t: 'Losing water', tag: 'leak', next: 'fill' },
        { t: 'Mostly cosmetic — I want it updated', tag: 'update', next: 'fill' }] },
      cracks: { q: 'How would you describe it?', o: [
        { t: 'Fine lines in the surface only', tag: 'hairline', next: 'fill' },
        { t: 'Wider, growing, offset or crumbling', tag: 'wide', next: 'fill' },
        { t: "I'm not sure", tag: 'wide', next: 'fill' }] },
      fill: { q: 'Is the pool filled or drained right now?', o: [{ t: 'Filled', tag: 'filled', next: 'goal' }, { t: 'Drained or partly drained', tag: 'drained', next: 'goal' }, { t: 'Not sure', next: 'goal' }] },
      goal: { q: 'What outcome are you hoping for?', o: [{ t: 'Fix a specific problem', tag: 'targeted', end: true }, { t: 'A complete restoration', tag: 'complete', end: true }, { t: 'Not sure — advise me', end: true }] },
    };
    var R = {
      leak: { title: 'Leak detection & assessment', services: ['Not sure — please advise'], text: 'Water loss can come from the shell, a skimmer, fittings or plumbing. Finding the source comes before any repair.', link: ['/pages/leak-detection-services', 'Leak detection'] },
      structural: { title: 'Structural assessment & repair', services: ['Structural / bond beam repair'], text: 'Cracking, spalling or crumbling concrete — especially at the bond beam, waterline or skimmer — should be assessed before anything is refinished.' },
      prep: { title: 'Sandblasting & two-part epoxy', services: ['Sandblasting & epoxy painting'], text: 'Failing paint has to come off — by abrasive blasting — before the concrete is repaired and a two-part epoxy system goes on.' },
      plaster: { title: 'Marcite / marbelite resurfacing', services: ['Marcite / marbelite resurfacing'], text: 'Worn plaster is usually renewed by preparing the shell and resurfacing — or converted to a coating, depending on its condition.' },
      tile: { title: 'Waterline tile replacement', services: ['Waterline tile'], text: 'Loose or cracked tile should be replaced with pool-rated materials before the next freeze lets water in behind it.' },
      coping: { title: 'Coping restoration', services: ['Coping'], text: 'Loose coping lets water into the bond beam. It is reset or replaced — and the beam checked underneath.' },
      full: { title: 'Complete restoration', services: ['Sandblasting & epoxy painting', 'Waterline tile', 'Coping'], text: 'A full restoration usually combines preparation and a new interior finish with tile, coping and any repairs found along the way.' },
      general: { title: 'Restoration assessment', services: ['Not sure — please advise'], text: 'We\'ll look at the shell, finish, tile, coping and fittings and recommend where to start.' },
    };
    var path = [], tags = {};
    function result() {
      if (tags.leak) return R.leak;
      if (tags.wide) return R.structural;
      if (tags.complete && !tags.tile && !tags.coping) return tags.plaster ? R.plaster : R.full;
      if (tags.peel) return R.prep;
      if (tags.plaster) return R.plaster;
      if (tags.tile) return R.tile;
      if (tags.coping) return R.coping;
      if (tags.update || tags.complete) return R.full;
      return R.general;
    }
    function recompute() { tags = {}; path.forEach(function (p) { if (p.tag) tags[p.tag] = true; }); guideAnswers = path.map(function (p) { return p.q + ' — ' + p.a; }); }
    function focusQ() { var h = $('.pbcp-quiz__q', box); if (h) h.focus({ preventScroll: true }); }
    function render() {
      var last = path[path.length - 1], node = last ? last.next : 'start', done = last && last.end;
      box.innerHTML = '';
      var top = document.createElement('div'); top.className = 'pbcp-quiz__top';
      var dots = document.createElement('div'); dots.className = 'pbcp-quiz__dots'; dots.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 5; i++) { var d = document.createElement('i'); if (i < Math.min(5, path.length + (done ? 0 : 1))) d.className = 'is-on'; dots.appendChild(d); }
      top.appendChild(dots);
      if (path.length) { var back = document.createElement('button'); back.type = 'button'; back.className = 'pbcp-quiz__back'; back.textContent = done ? 'Start over' : 'Back';
        back.addEventListener('click', function () { if (done) path = []; else path.pop(); recompute(); render(); focusQ(); }); top.appendChild(back); }
      box.appendChild(top);
      if (done) {
        var r = result();
        var w = document.createElement('div'); w.className = 'pbcp-quiz__result';
        w.innerHTML = '<p class="pbcp-eyebrow">Suggested starting point</p><h3 class="pbcp-quiz__q" tabindex="-1"></h3><p class="pbcp-r-text"></p><p class="pbcp-note" hidden></p>' +
          '<div class="pbcp-quiz__actions"><button type="button" class="pbcp-btn pbcp-btn--solid" data-go>Use this in my request</button></div><p class="pbcp-fine">A preliminary guide based on your answers — not a diagnosis. Every pool needs an on-site assessment.</p>';
        w.querySelector('h3').textContent = r.title + (tags.commercial ? ' (commercial)' : '');
        w.querySelector('.pbcp-r-text').textContent = r.text;
        if (r !== R.tile && r !== R.coping && r !== R.leak) { var n = w.querySelector('.pbcp-note'); n.hidden = false; n.textContent = tags.drained ? 'If your pool is already drained, let us know how long it has been empty — groundwater can affect an empty shell.' : 'Most of this work needs the pool drained. Groundwater conditions are checked first.'; }
        if (r.link) { var lp = document.createElement('p'); lp.className = 'pbcp-fine'; var a = document.createElement('a'); a.href = r.link[0]; a.textContent = r.link[1]; lp.appendChild(document.createTextNode('See also: ')); lp.appendChild(a); w.appendChild(lp); }
        w.querySelector('[data-go]').addEventListener('click', function () { toForm(r); });
        box.appendChild(w); return;
      }
      var q = Q[node];
      var h = document.createElement('h3'); h.className = 'pbcp-quiz__q'; h.tabIndex = -1; h.textContent = q.q; box.appendChild(h);
      var opts = document.createElement('div'); opts.className = 'pbcp-quiz__opts';
      q.o.forEach(function (o) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = o.t;
        if (o.s) { var s = document.createElement('small'); s.textContent = o.s; b.appendChild(s); }
        b.addEventListener('click', function () { path.push({ q: q.q, a: o.t, next: o.next, end: o.end, tag: o.tag }); recompute(); render(); focusQ(); });
        opts.appendChild(b);
      });
      box.appendChild(opts);
    }
    function toForm(r) {
      $$('input[name="services"]').forEach(function (c) { c.checked = r.services.indexOf(c.value) >= 0; });
      setType(tags.commercial ? 'Commercial' : 'Residential');
      var sum = $('[data-pbcp-guide-summary]');
      if (sum) { sum.hidden = false; sum.innerHTML = '<strong>From the guide:</strong> '; sum.appendChild(document.createTextNode(r.title + '. ' + guideAnswers.join(' · '))); }
      var st = $('#f-state'); if (st) st.value = tags.drained ? 'Drained' : tags.filled ? 'Filled' : '';
      var f = $('[data-pbcp-form]'); f.scrollIntoView({ behavior: smooth(), block: 'start' });
      setTimeout(function () { var n = $('#f-name'); n && n.focus({ preventScroll: true }); }, reduce ? 0 : 600);
    }
    render();
  })();

  /* ---------- request form ---------- */
  (function form() {
    var f = $('[data-pbcp-form]'); if (!f) return;
    var mode = f.getAttribute('data-mode') || 'endpoint';
    var err = $('[data-pbcp-form-error]', f), btn = $('[data-pbcp-submit]', f), success = $('[data-pbcp-success]');
    var fileInput = $('#f-photos'), thumbs = $('[data-pbcp-thumbs]'), files = [];
    var MAX = 8, started = Date.now(), label = btn.textContent;
    if (mode === 'shopify') { var up = $('[data-pbcp-upload]', f); if (up) up.remove(); var alt = $('[data-pbcp-upload-alt]', f); if (alt) alt.hidden = false; }

    // residential / commercial
    function syncType() {
      var com = ($('input[name="project_type"]:checked', f) || {}).value === 'Commercial';
      $$('[data-commercial-only]', f).forEach(function (el) { el.hidden = !com; });
    }
    $$('input[name="project_type"]', f).forEach(function (r) { r.addEventListener('change', syncType); });
    syncType();

    function drawThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      files.forEach(function (file, i) {
        var li = document.createElement('li'); var img = document.createElement('img'); img.alt = ''; img.src = URL.createObjectURL(file);
        img.onload = function () { URL.revokeObjectURL(img.src); };
        var x = document.createElement('button'); x.type = 'button'; x.textContent = 'Remove'; x.setAttribute('aria-label', 'Remove ' + file.name);
        x.addEventListener('click', function () { files.splice(i, 1); drawThumbs(); });
        li.appendChild(img); li.appendChild(x); thumbs.appendChild(li);
      });
    }
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        Array.prototype.forEach.call(fileInput.files, function (file) { if (files.length < MAX && /^image\//.test(file.type) && file.size < 25e6) files.push(file); });
        fileInput.value = ''; drawThumbs();
      });
      var drop = fileInput.closest('.pbcp-drop');
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('is-over'); }); });
    }
    function shrink(file) {
      return new Promise(function (res) {
        if (!window.createImageBitmap || file.size < 1.5e6) return res(file);
        createImageBitmap(file).then(function (bmp) {
          var s = Math.min(1, 2000 / Math.max(bmp.width, bmp.height));
          var c = document.createElement('canvas'); c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
          c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
          c.toBlob(function (b) { res(b ? new File([b], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.85);
        }).catch(function () { res(file); });
      });
    }
    function setErr(input, msg) {
      var id = input.id + '-err', e = document.getElementById(id);
      if (msg) {
        input.setAttribute('aria-invalid', 'true');
        if (!e) { e = document.createElement('span'); e.className = 'pbcp-ferr'; e.id = id; (input.closest('.pbcp-field') || input.parentNode).appendChild(e); }
        e.textContent = msg; input.setAttribute('aria-describedby', id);
      } else { input.removeAttribute('aria-invalid'); if (e) e.remove(); input.removeAttribute('aria-describedby'); }
    }
    function validate() {
      var bad = null;
      [['#f-name', function (v) { return v.trim().length > 1 || 'Please enter your name.'; }],
       ['#f-email', function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) || 'Please enter a valid email address.'; }],
       ['#f-phone', function (v) { return v.replace(/\D/g, '').length >= 10 || 'Please enter a phone number we can reach you at.'; }],
       ['#f-address', function (v) { return v.trim().length > 4 || 'Please enter the pool\'s address or town.'; }]].forEach(function (c) {
        var el = $(c[0], f); var ok = c[1](el.value); setErr(el, ok === true ? '' : ok); if (ok !== true && !bad) bad = el;
      });
      var consent = $('[name="consent"]', f);
      if (!consent.checked) { if (!bad) bad = consent; err.hidden = false; err.textContent = 'Please confirm we can contact you about this request.'; } else if (!bad) err.hidden = true;
      if (bad) bad.focus();
      return !bad;
    }
    $$('input, select, textarea', f).forEach(function (el) { el.addEventListener('blur', function () { if (el.getAttribute('aria-invalid')) validate(); }); });
    function summaryText() {
      var fd0 = new FormData(f), lines = ['CONCRETE POOL RESTORATION REQUEST'];
      var fd = { get: function (k) { return fd0.get(k) || fd0.get('contact[' + k + ']'); }, getAll: function (k) { return fd0.getAll(k); } };
      [['project_type', 'TYPE'], ['name', 'NAME'], ['organization', 'ORGANIZATION'], ['email', 'EMAIL'], ['phone', 'PHONE'], ['address', 'LOCATION'], ['facility', 'FACILITY'],
       ['size', 'SIZE'], ['state', 'POOL IS'], ['finish', 'CURRENT FINISH'], ['timing', 'TIMING'], ['consultation', 'ON-SITE CONSULTATION'], ['message', 'DETAILS']].forEach(function (k) { var v = fd.get(k[0]); if (v) lines.push(k[1] + ': ' + v); });
      var sv = fd.getAll('services'); if (sv.length) lines.push('SERVICES: ' + sv.join(', '));
      if (guideAnswers.length) lines.push('GUIDE: ' + guideAnswers.join(' | '));
      if (files.length) lines.push('PHOTOS ATTACHED: ' + files.length);
      return lines.join('\n');
    }
    function reveal() { if (f.contains(success)) f.parentNode.insertBefore(success, f.nextSibling); f.hidden = true; success.hidden = false; }
    function done(ref) {
      reveal();
      $('[data-pbcp-ref]', success).textContent = ref;
      $('[data-pbcp-ref-photos]', success).textContent = files.length ? ' and ' + files.length + ' photo' + (files.length > 1 ? 's' : '') : '';
      success.focus();
    }
    f.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); return; }
      if ($('[name="company_website"]', f).value || Date.now() - started < 2500) { e.preventDefault(); return; } // bot traps
      if (mode === 'shopify') {
        // native Shopify contact POST: Liquid renders the confirmation only after Shopify accepts it
        var body = f.querySelector('[name="contact[body]"]'); if (body) body.value = summaryText();
        btn.disabled = true; btn.textContent = 'Sending…';
        return;
      }
      e.preventDefault();
      var endpoint = f.getAttribute('data-endpoint');
      if (!endpoint) { err.hidden = false; err.textContent = 'This form is not connected yet. Please call (289) 929-7665.'; return; }
      btn.disabled = true; btn.textContent = 'Sending…'; err.hidden = true;
      Promise.all(files.map(shrink)).then(function (ready) {
        var fd = new FormData(f); fd.delete('photos');
        ready.forEach(function (file) { fd.append('photos', file, file.name); });
        fd.append('summary', summaryText());
        var ctrl = 'AbortController' in window ? new AbortController() : null;
        var timer = setTimeout(function () { ctrl && ctrl.abort(); }, 45000);
        return fetch(endpoint, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, signal: ctrl && ctrl.signal })
          .then(function (r) { clearTimeout(timer); return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && j.ok !== false, j: j }; }); });
      }).then(function (res) {
        if (!res.ok) throw new Error('not received');
        done(res.j.reference || res.j.id || 'PBCP-' + Date.now().toString(36).toUpperCase());
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        err.hidden = false; err.textContent = 'Your request didn\'t go through. Please try again, or call (289) 929-7665.';
      });
    });
    // Shopify mode: Liquid marks the box only after Shopify accepted the POST
    if (success && success.hasAttribute('data-pbcp-posted')) {
      reveal();
      var r = $('[data-pbcp-ref]', success); if (r && !r.textContent) r.parentNode.textContent = "We'll review your details and contact you to arrange an on-site consultation. If you have photos, email them to sales@poolbusters.ca with your name.";
      success.scrollIntoView({ block: 'center' }); success.focus({ preventScroll: true });
    }
  })();

  /* ---------- mobile action bar ---------- */
  (function mobilebar() {
    var bar = $('[data-pbcp-mobilebar]'); if (!bar || !('IntersectionObserver' in window)) return;
    if (document.querySelector('.pb-launch-bar, [data-pb-launch-bar]')) { bar.remove(); return; } // theme already provides one
    var heroOut = false, formIn = false;
    var upd = function () { bar.classList.toggle('is-on', heroOut && !formIn); };
    new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting; upd(); }).observe($('.pbcp-hero'));
    new IntersectionObserver(function (es) { formIn = es[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -30% 0px' }).observe($('#quote'));
  })();
})();
